import { takeLatest, put, select } from 'redux-saga/effects';

import ProjectService from '../../../services/ProjectService';
import {
  getProjectFail,
  getProjectRequest,
  getProjectSuccess,
  getProjectListFail,
  getProjectListRequest,
  getProjectListSuccess,
  saveProjectFail,
  saveProjectRequest,
  saveProjectSuccess,
  createProjectRequest,
  createProjectSuccess,
  createProjectFail,
  deleteProjectRequest,
  deleteProjectSuccess,
  deleteProjectFail,
  setProjectListDirty,
  initProjectRequest,
  initProjectSuccess,
  initProjectFail,
  duplicateProjectRequest,
  duplicateProjectSuccess,
  duplicateProjectFail,
  clearProjectList,
  getProjectRefreshRequest,
  getProjectRefreshSuccess, updateProjectStatusRequest, updateProjectStatusSuccess, updateProjectStatusFail,
} from './actions';
import { logOut } from '../auth/actions';
import { apiCall } from '../../effects';
import { getErrorNotification } from '../../util';
import { notify } from '../notifications/actions';
import { Project } from '../../../types/items';
import { selectProject } from './selectors';

function* getProjectList({
  payload,
}: ReturnType<typeof getProjectListRequest>) {
  try {
    const list = yield apiCall(ProjectService.list, payload);
    yield put(getProjectListSuccess(list));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(getProjectListFail());
  }
}

function* getProject({ payload }: ReturnType<typeof getProjectRequest>) {
  try {
    const response = yield apiCall(ProjectService.get, payload);
    yield put(getProjectSuccess(response));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(getProjectFail());
  }
}

function* saveProject({ payload }: ReturnType<typeof saveProjectRequest>) {
  try {
    const response = yield apiCall(ProjectService.save, payload.id, payload);
    yield put(saveProjectSuccess(response));
    //
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(saveProjectFail());
  }
}

function* createProject({ payload }: ReturnType<typeof createProjectRequest>) {
  try {
    const response = yield apiCall(ProjectService.create, payload);
    yield put(createProjectSuccess(response));
  } catch (e) {
    yield put(initProjectSuccess(payload));
    yield put(notify(getErrorNotification(e)));
    yield put(createProjectFail());
  }
}

function* updateProjectStatus({ payload }: ReturnType<typeof updateProjectStatusRequest>) {
  try {
    const { data: project } = yield select(selectProject);
    const newProject = { ...project, status_id: payload } as Project;
    const response = yield apiCall(ProjectService.save, newProject.id, newProject);

    yield put(updateProjectStatusSuccess(response));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(updateProjectStatusFail());
  }
}

function* deleteProject({ payload }: ReturnType<typeof deleteProjectRequest>) {
  try {
    yield apiCall(ProjectService.delete, payload);
    yield put(deleteProjectSuccess());
    yield put(setProjectListDirty(true));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(deleteProjectFail());
  }
}

function* getTemplateProject() {
  try {
    const response = yield apiCall(ProjectService.template);
    yield put(initProjectSuccess(response));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(initProjectFail());
  }
}

function* duplicateProject({ payload }: ReturnType<typeof duplicateProjectRequest>) {
  try {
    const response = yield apiCall(ProjectService.duplicate, payload);
    yield put(duplicateProjectSuccess(response));
    yield put(setProjectListDirty(true));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(duplicateProjectFail());
  }
}

function* clearList() {
  yield put(clearProjectList());
}

function* getProjectRefresh({ payload }: ReturnType<typeof getProjectRefreshRequest>) {
  try {
    const response = yield apiCall(ProjectService.get, payload);
    yield put(getProjectRefreshSuccess(response));
  } catch (e) {

  }
}

export default [
  takeLatest(getProjectListRequest.type, getProjectList),
  takeLatest(getProjectRequest.type, getProject),
  takeLatest(saveProjectRequest.type, saveProject),
  takeLatest(createProjectRequest.type, createProject),
  takeLatest(updateProjectStatusRequest.type, updateProjectStatus),
  takeLatest(deleteProjectRequest.type, deleteProject),
  takeLatest(initProjectRequest.type, getTemplateProject),
  takeLatest(duplicateProjectRequest.type, duplicateProject),
  takeLatest(logOut.type, clearList),
  takeLatest(getProjectRefreshRequest.type, getProjectRefresh),
];
